import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchool = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M12 10h16v12h4v10H8V22h4z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M24 23h-8v9h8z"
    />
    <circle
      cx={20}
      cy={16}
      r={3}
      fill="#00C5F2"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchool);

export default ForwardRef;
